module.exports = __webpack_public_path__ + "static/media/nima-look2.8e456c18.png";